// Mobile Google Calendar connect: full-page redirect (iPhone Safari blocks the popup flow).
// Google sends the user back to <origin>/google-callback?code=...&state=..., and GoogleCallback hands the code
// to /api/google-calendar with the same redirect_uri. Desktop keeps the popup.
export const REDIRECT_PATH = '/google-callback';
const STATE_KEY = 'resi.googleOAuth';

export const isMobileBrowser = (ua = (typeof navigator !== 'undefined' ? navigator.userAgent : ''), maxTouch = (typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0)) =>
  /iPhone|iPad|iPod|Android|Mobile/i.test(ua) || (/Macintosh/.test(ua) && maxTouch > 1); // iPadOS reports as Mac

export const redirectUriFor = (origin) => `${String(origin || '').replace(/\/$/, '')}${REDIRECT_PATH}`;

export const buildAuthUrl = ({ clientId, scope, redirectUri, state }) => {
  const q = new URLSearchParams({ client_id: clientId, redirect_uri: redirectUri, response_type: 'code', scope: `openid email ${scope}`,
    access_type: 'offline', prompt: 'consent', include_granted_scopes: 'false', state });
  return `https://accounts.google.com/o/oauth2/v2/auth?${q.toString()}`;
};

const randomState = () => {
  const a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a);
  return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
};

// Saves state + where to come back to, then leaves the page for Google.
export const startRedirectConnect = ({ clientId, scope, returnTo = '/profile', storage = window.sessionStorage, go = (u) => window.location.assign(u), origin = window.location.origin }) => {
  const state = randomState();
  const redirectUri = redirectUriFor(origin);
  storage.setItem(STATE_KEY, JSON.stringify({ state, returnTo, redirectUri, at: Date.now() }));
  go(buildAuthUrl({ clientId, scope, redirectUri, state }));
  return { state, redirectUri };
};

// Reads ?code&state (or ?error) on the callback page and checks the state matches the one we saved (15 min max).
export const readCallback = (search, storage = window.sessionStorage, now = Date.now()) => {
  const p = new URLSearchParams(search || '');
  let saved = null; try { saved = JSON.parse(storage.getItem(STATE_KEY) || 'null'); } catch (e) { saved = null; }
  storage.removeItem(STATE_KEY);
  const returnTo = (saved && /^\/[A-Za-z0-9/_-]*$/.test(saved.returnTo || '') ? saved.returnTo : '/profile');
  if (p.get('error')) return { ok: false, returnTo, message: p.get('error') === 'access_denied' ? 'Google Calendar access was not allowed.' : `Google said: ${p.get('error')}` };
  if (!saved || !p.get('state') || p.get('state') !== saved.state || now - (saved.at || 0) > 15 * 60000) return { ok: false, returnTo, message: 'The Google sign-in expired or did not match. Please tap Connect again.' };
  if (!p.get('code')) return { ok: false, returnTo, message: 'Google did not send a sign-in code. Please try again.' };
  return { ok: true, code: p.get('code'), redirectUri: saved.redirectUri, returnTo };
};
